import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ResponsableMetaBean } from 'src/app/_beans/ResponsableMetaBean';
import { UnidadOrganicaBean } from 'src/app/_beans/UnidadOrganicaBean';

@Component({
  selector: 'app-add-responsable-meta',
  templateUrl: './add-responsable-meta.component.html',
  styleUrls: ['./add-responsable-meta.component.scss']
})
export class AddResponsableMetaComponent implements OnInit {
  responsable: ResponsableMetaBean;
  entidadList: UnidadOrganicaBean[] = [];
  despachoList: UnidadOrganicaBean[] = [];
  direccionGeneralList: UnidadOrganicaBean[] = [];
  direccionLineaList: UnidadOrganicaBean[] = [];
  areaList: UnidadOrganicaBean[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    public sharedService: SharedService,
    private restProvider: RestProviderService,
    public constantes: ConstantesService,
    public dialogRef: MatDialogRef<AddResponsableMetaComponent>,
    ) { }


  ngOnInit(): void {
    this. responsable= new ResponsableMetaBean();
    this.responsable.entidad=new UnidadOrganicaBean();
    this.responsable.despacho=new UnidadOrganicaBean();
    this.responsable.direccionGeneral=new UnidadOrganicaBean();
    this.responsable.direccionLinea=new UnidadOrganicaBean();
    this.responsable.area=new UnidadOrganicaBean();
    this.obtenerEntidades();
  }

  public cerrar(responsableMeta?: ResponsableMetaBean) {
    responsableMeta ? this.dialogRef.close(responsableMeta) : this.dialogRef.close();
  }

  public addUnidadOrganica(){
    if(this.responsable.area && this.responsable.area.id){
      this.responsable.unidadOrganica=this.responsable.area;
    }else{
      if(this.responsable.direccionLinea && this.responsable.direccionLinea.id){
        this.responsable.unidadOrganica=this.responsable.direccionLinea;
      }else{
        if(this.responsable.direccionGeneral && this.responsable.direccionGeneral.id){
          this.responsable.unidadOrganica=this.responsable.direccionGeneral;
        }else{
          if(this.responsable.despacho && this.responsable.despacho.id){
            this.responsable.unidadOrganica=this.responsable.despacho;
          }else{
           if(this.responsable.entidad && this.responsable.entidad.id){
              this.responsable.unidadOrganica=this.responsable.entidad;
            }
          }
        }
      }
    }
    this.cerrar(this.responsable);
  };


  public obtenerEntidades() {
    this.restProvider.executeHttpMethod("/uoc/le", {}).subscribe((result: any) => {
      this.entidadList = result.datalist;
    })
  }

  public cargarSelectHijos(unidadOrganica : UnidadOrganicaBean,nivel:string){
    let params = {
      data: {
          id: unidadOrganica.id
      }
    }
    this.restProvider.executeHttpMethod("/uoc/luohd", params).subscribe((result: any) => {
      if(nivel){
        switch(nivel){
          case '1':this.direccionGeneralList=result.datalist;
                    this.direccionLineaList=[];
                    this.areaList=[];
                    this.responsable.direccionLinea=new UnidadOrganicaBean();
                    this.responsable.area=new UnidadOrganicaBean();
                  break;
          case '2':this.direccionLineaList=result.datalist;
                    this.areaList=[];
                    this.responsable.area=new UnidadOrganicaBean();
                    break;
          case '3':this.areaList=result.datalist;break;
        }
      }else{
        this.despachoList=result.datalist
          this.direccionGeneralList=[];
          this.direccionLineaList=[];
          this.areaList=[];
          this.responsable.direccionGeneral=new UnidadOrganicaBean();
          this.responsable.direccionLinea=new UnidadOrganicaBean();
          this.responsable.area=new UnidadOrganicaBean();
      }
    })
  }

}
